<div class="container-fluid card p-3 mt-3" *ngIf="!isLoading && groupSession">
  <h2 class="mb-3 text-primary">Group Session Topic Details</h2>
  <table class="table table-bordered">
    <tbody>
    <tr>
      <th>Content</th>
      <td>{{ groupSession.content }}</td>
    </tr>
    <tr>
      <th>Detailed Description</th>
      <td>
        <a
          [href]="groupSession.detailedDescription"
          target="_blank"
        >
          {{ extractFileName(groupSession.detailedDescription) }}
        </a>
      </td>
    </tr>

    <tr>
      <th>File URLs</th>
      <td>
        <ul *ngIf="groupSession.presentationUrls && groupSession.presentationUrls.length; else noFiles">
          <li *ngFor="let file of groupSession.presentationUrls">
            <a [href]="file" target="_blank">{{ extractFileName(file) }}</a>
          </li>
        </ul>
        <ng-template #noFiles>No files uploaded</ng-template>
      </td>
    </tr>

    <tr>
      <th>Description</th>
      <td>{{ groupSession.description }}</td>
    </tr>

    </tbody>
  </table>
  <div class="row justify-content-center d-flex mt-3">
    <div class="col-md-4">
      <button mat-raised-button color="warn" routerLink="/home/counseling/group-session-topics-list">
        Back to List
      </button>
    </div>
  </div>
</div>
<div class="spinner-container" *ngIf="isLoading">
  <mat-spinner diameter="60"></mat-spinner>
</div>
